class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.content = this.summaryToggle ? this.summaryToggle.nextElementSibling : null;
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));

    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    }
    else if (this.dataset.open == undefined) {
      this.detailsContainer.removeAttribute('open');
    }
    else {
      this.detailsContainer.setAttribute('open', true);
    }
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (!theme.config.mqlSmall || this.summaryIsEmpty) return;

    this.detailsContainer.style.overflow = 'hidden';
    if (this.isClosing || !this.detailsContainer.open) {
      this.open();
    }
    else if (this.isExpanding || this.detailsContainer.open) {
      this.shrink();
    }
  }

  shrink() {
    if (!theme.config.mqlSmall || this.summaryIsEmpty) return;

    this.isClosing = true;

    const summaryStyle = window.getComputedStyle(this.summaryToggle);
    const startHeight = `${this.detailsContainer.offsetHeight}px`;
    const endHeight = `${this.summaryToggle.offsetHeight + parseInt(summaryStyle.marginTop)}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.detailsContainer.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 250,
      easing: 'ease'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);
      return;
    }

    this.detailsContainer.style.height = `${this.detailsContainer.offsetHeight}px`;
    this.detailsContainer.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const summaryStyle = window.getComputedStyle(this.summaryToggle);
    const startHeight = `${this.detailsContainer.offsetHeight}px`;
    const endHeight = `${this.summaryToggle.offsetHeight + parseInt(summaryStyle.marginTop) + (this.content ? this.content.offsetHeight : 0)}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.detailsContainer.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  close() {
    if (theme.config.mqlSmall && !this.summaryIsEmpty && this.dataset.open == undefined) {
      this.detailsContainer.removeAttribute('open');
    }
  }

  onAnimationFinish(open) {
    this.detailsContainer.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.detailsContainer.style.height = this.detailsContainer.style.overflow = '';
  }
}

customElements.define('footer-accordion', FooterAccordion);
